module.exports = __webpack_public_path__ + "img/DLP_LOGO_W.680e67cf.png";